import React, { useState, useEffect } from "react"; // Added useEffect
import { useParams, useNavigate } from "react-router-dom"; // Added useParams
import { simplePostCall } from "../api/ApiServices";
import ApiConfig from "../api/ApiConfig";
import { toast, ToastContainer } from "react-toastify";

export default function Createfee() {
  const { id } = useParams(); // Get ID from URL
  const navigate = useNavigate();
  const isEditMode = !!id; // Boolean: true if ID exists

  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    category_name: "",
    category_type: "",
    amount_type: "",
    applicable_to: "",
  });
  console.log("formData", formData);

  // --- 1. VIEW LOGIC (Fetch data if in Edit Mode) ---
  useEffect(() => {
    if (isEditMode) {
      loadFeeCategory();
    }
  }, [id]);

  const loadFeeCategory = async () => {
    setIsLoading(true);
    const requestBody = {
      customer_id: Number(localStorage.getItem("customer_id")),
      api_key: localStorage.getItem("api_key"),
      category_id: Number(id),
    };

    try {
      const response = await simplePostCall(
        ApiConfig.feeCategoryview,
        JSON.stringify(requestBody),
      );

      if (response?.result && response.data?.length > 0) {
        const data = response.data[0];
        // Populate form with existing data
        setFormData({
          category_name: data.fee_category_name || "",
          category_type: data.fee_category_type || "",
          amount_type: data.fee_category_amount_type || "",
          applicable_to: data.fee_category_applicable_to || "",
        });
      }
    } catch (error) {
      console.error("Error loading category:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // --- 2. HANDLE INPUT CHANGES ---
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // --- 3. ADD / UPDATE LOGIC ---
  const handleProcessForm = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");

    // Base request body
    const requestBody = {
      customer_id: Number(customer_id),
      api_key: api_key,
      category_name: formData.category_name,
      category_type: formData.category_type,
      amount_type: formData.amount_type,
      applicable_to: formData.applicable_to,
    };

    // Add ID if updating
    if (isEditMode) {
      requestBody.category_id = Number(id);
      requestBody.user_id = localStorage.getItem("user_id");
    }

    const apiEndpoint = isEditMode
      ? ApiConfig.feeCategoryEDit
      : ApiConfig.feeCategorycreate;

    try {
      const response = await simplePostCall(
        apiEndpoint,
        JSON.stringify(requestBody),
      );

      if (response?.result) {
        toast.success(
          isEditMode ? "Updated Successfully!" : "Created Successfully!",
          {
            position: "top-right",
            autoClose: 2000,
          },
        );
        setTimeout(() => {
          navigate("/Feecategory");
        }, 2000);
      } else {
        toast.error(response?.message || "Operation failed", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred.", {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="createfee-container">
      <ToastContainer />
      <div className="special-header panel-white-all">
        <h4 className="page-title">
          {isEditMode ? "Update" : "Create"} Fee Category
        </h4>
      </div>

      <div className="yc-list-body">
        <div className="card">
          <div className="card-body">
            <form onSubmit={handleProcessForm}>
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">Category Name *</label>
                  <input
                    type="text"
                    name="category_name"
                    value={formData.category_name}
                    onChange={handleChange}
                    className="form-control"
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Category Type *</label>
                  <select
                    name="category_type"
                    value={formData.category_type}
                    onChange={handleChange}
                    className="form-select"
                    required
                  >
                    <option value="">Select Category Type</option>
                    <option value="fee">Fee</option>
                    <option value="discount">Discount</option>
                    <option value="bonus">Bonus</option>
                    <option value="special fee">Special Fee</option>
                  </select>
                </div>

                <div className="col-md-6">
                  <label className="form-label">Amount Type</label>
                  <select
                    name="amount_type"
                    value={formData.amount_type}
                    onChange={handleChange}
                    className="form-select"
                  >
                    <option value="">Select Amount Type</option>
                    <option value="percentage">Percentage</option>
                    <option value="amount">Amount</option>
                  </select>
                </div>

                <div className="col-md-6">
                  <label className="form-label">Applicable To</label>
                  <select
                    name="applicable_to"
                    value={formData.applicable_to}
                    onChange={handleChange}
                    className="form-select"
                  >
                    <option value="">Select Applicable To</option>
                    <option value="all students">All Students</option>
                    <option value="new students">New Students</option>
                    <option value="selected students">Selected Students</option>
                  </select>
                </div>

                <div className="col-12 d-flex justify-content-end">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isLoading}
                  >
                    {isLoading ? "Processing..." : isEditMode ? "Update" : "Add"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
